import { Component, OnInit } from '@angular/core';
//import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap'; 
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl, 
import { Router } from '@angular/router'; //, NavigationExtras

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})


export class FooterComponent implements OnInit {

  subscriber;
  social_url;

  constructor(
    public builder:FormBuilder,
    public bp:BasicProvider, 
    public up:UserProvider,
    public router: Router,
  ) {
    this.setSubscriberForm();
    this.social_url = this.up.getSocialData();
  }
  currentYear;

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

  public setSubscriberForm(){
    this.subscriber = this.builder.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern('([a-zA-Z0-9_.]{1}[a-zA-Z0-9_.]*)((@[a-zA-Z\-]{2}[a-zA-Z\-]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))([\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))?')])],
    })
  }

  keyDownFunction(event) {
    if(event.keyCode == 13) {
      this.subscribeFormSubmit();
      // rest of your code
    }
  }

  
  public subscribeFormSubmit () {
    let p = window.location.pathname.replace(this.bp.SUBFOLDER_NAME, "")
    
    if(this.bp.validation(this.subscriber)) {
      this.bp.validation_error = '';
      let submitData = this.subscriber.value;
      
      this.bp.hitApi('web/save_subscriber', 'POST', submitData,true,true)
      .subscribe(
        success => {
          if(success.type) {   
            this.subscriber.reset(); // or form.reset();
            this.setSubscriberForm();
            this.bp.show_toast('Success',success.message);
          } else {
            this.setSubscriberForm();
            this.bp.show_toast('Error',success.message);
            //this.bp.validation_error = success.message;
          }
        }, error => {}
      )
    } else {
      this.bp.show_toast('Error',this.bp.validation_error);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts